export type GrantTeamManagerDepartment = {
  id: number;
  name: string;
  member_count: number;
  opportunity_count: number;
};

export type GrantTeamManagerInviteRequest = {
  id: number;
  email: string;
  external_organization_id: number;
  external_organization_name: string;
  requested_at: string;
};

export type GrantTeamManagerOverview = {
  team_id: number;
  departments: GrantTeamManagerDepartment[];
  pending_invite_requests: GrantTeamManagerInviteRequest[];
};

/**
 * 403 here is the real access control (GrantSuite::TeamManagerGate); the
 * hidden tab is only a convenience. A denial is a different fact than an
 * outage, so the panel can say the right thing for each.
 */
export class GrantTeamManagerForbiddenError extends Error {
  constructor() {
    super("Not a Grant Team Manager for this workspace team");
    this.name = "GrantTeamManagerForbiddenError";
  }
}

export async function getGrantTeamManagerOverview(
  municipalityId: number,
): Promise<GrantTeamManagerOverview> {
  const response = await fetch(`/api/v1/municipalities/${municipalityId}/grant_team_manager`, {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (response.status === 403) {
    throw new GrantTeamManagerForbiddenError();
  }
  if (!response.ok) {
    throw new Error("Failed to load the Team Manager overview");
  }
  return response.json();
}

export function grantTeamManagerQueryKey(municipalityId: number | undefined) {
  return ["grant_team_manager", municipalityId] as const;
}
